/** PostHog event names for RequestFormV2 analytics (WEB-10991). */
export const QUOTE_REQUEST_FORM_V2_EVENTS = {
  ENTER_FORM: "RequestFormV2: Enter Form",
  LOAD_TEMPLATE: "RequestFormV2: Load Template",
  ABANDON_SECTION: "RequestFormV2: Abandon Section",
  REENTER_DRAFT: "RequestFormV2: Reenter Draft",
  SAVE_DRAFT: "RequestFormV2: Save Draft",
  ADD_HANDLING_UNIT: "RequestFormV2: Add Handling Unit",
  ADD_CONTAINER: "RequestFormV2: Add Container",
  ADD_COMMODITY: "RequestFormV2: Add Commodity",
  SELECT_ALL_PROVIDERS: "RequestFormV2: Select All Providers",
  FILTER_PROVIDERS: "RequestFormV2: Filter Providers",
  LOG_FORM_ERROR: "RequestFormV2: Log Form Error",
  VIEW_CONFIRMATION: "RequestFormV2: View Confirmation",
  BACK_TO_EDITING: "RequestFormV2: Back To Editing",
  SUBMIT_FORM: "RequestFormV2: Submit Form",
} as const;

export type QuoteRequestFormV2EventName =
  (typeof QUOTE_REQUEST_FORM_V2_EVENTS)[keyof typeof QUOTE_REQUEST_FORM_V2_EVENTS];
